import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AccountsservicesService } from 'src/app/shared/services/accountservices/accountsservices.service';
import { AttendanceService } from 'src/app/shared/services/attendanceservices/attendance.service';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { CommonModule, Location } from '@angular/common';
import Swal from 'sweetalert2';
import { FormsModule, NgForm } from '@angular/forms';
import { ExportAsConfig, ExportAsService } from 'ngx-export-as';
import * as XLSX from 'xlsx';
import { AgChartOptions } from 'ag-charts-community';
import { DomSanitizer } from '@angular/platform-browser';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { AgChartsAngularModule } from 'ag-charts-angular';

declare let $: any;
@Component({
  selector: 'app-admin-accounts',
  templateUrl: './admin-accounts.component.html',
  styleUrl: './admin-accounts.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule, AgChartsAngularModule, NgApexchartsModule]
})
export class AdminAccountsComponent implements OnInit {
  @ViewChild('errorModal') errorModal!: ElementRef;
  @ViewChild('addexpense') addExpenseModal!: ElementRef;
  @ViewChild('selectElement') selectElement!: ElementRef;
  public showSpinner = true;
  user: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;

  currentTab = 1;
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 100;
  graphdataArray: any = [];
  isExpanded = false;
  datamode: any;
  showHiddenDiv1 = false;
  typeArr: any = [];
  public overtime: any = '';
  public workingHours: any = '';
  public stats: any = [];
  public checkInStatus: any = '';
  public checkStats = false;
  public checkInTime: any = '';

  public leaves: any[] = [];
  public paidLeaves: any[] = [];
  public unpaidLeaves: any[] = [];
  public actionattendance: any[] = [];
  public startdate: any;
  public endDate: any;
  public filterType = "";
  public filterMonth = "";
  public topState: any[] = [];
  shiftRemainingTime = "00:00:00";
  percentageInProgress = 100;
  checkInArrayForGraph: any[] = [];
  checkOutArrayForGraph: any[] = [];
  checkInChartData: any = {};
  checkOutChartData: any = {};
  checkInData: any[] = [];
  checkOutData: any[] = [];
  isPrintPage = false;
  printingContent: any = {};
  checkInDays: any[] = [];
  checkOutDays: any[] = [];
  secondShitEmployees = [46, 55, 60, 63, 61, 73, 112];
  checkOutDate: any;
  totalHours = 0;
  checkOutTime = "";
  checkInDate: any;
  account_type: any;
  user_Amount: any[] = [];
  total_Amount: any;
  expense: any;
  reserve: any;
  deposit: any;
  accountData: any[] = [];
  originalData: any[] = [];
  showErrorModal = false;
  options: AgChartOptions = {
    series: [
      {
        data: this.graphdataArray,
        type: "pie",
        calloutLabelKey: "amount",
        sectorLabelKey: "gdppermonth",
        angleKey: "availibleamount",
        radiusKey: "gdppermonth",
      },
    ],

  };
  selectedOption = '';
  user_reserve: any[] = [];
  exportType = '';
  form_data: any;
  modalData: any;
  editeamount: any;
  editedate: any;
  editedescription: any;
  editeexpense_type: any;
  tab: any;
  startDate: any;
  start_Date: any;
  end_Date: any;
  filtedata: any;
  account_id: any;
  id: any;
  selectedtab = 'mydata';
  apiData: any[] = []; // assuming this is where you store your API data
  selectedCategory: number | null = null;
  subcategories: any[] = [];
  selectedSubcategory: any;
  selectedFile: any;
  imageUrl: any;
  media: any;
  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private sharedmode: SharedModeService,
    public dashboardService: DashboardService,
    private attendanceService: AttendanceService,
    private accountsServices: AccountsservicesService,
    private _location: Location,
    private exportAsService: ExportAsService,
    private sanitizer: DomSanitizer



  ) {
    this.user = JSON.parse(localStorage.getItem('user') || ''),
      this.user_detail();
    // this.useramount();
    this.admindata();
    this.totalamount();
    this.chartvalue();

    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type != "Admin") {
      this.router.navigate(['/dashboard-1']);
    }
  }

  ngOnInit(): void {
    this.showSpinner = false;
    this.getCategory();


    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  getCategory() {
    this.showSpinner = true;
    this.accountsServices.getcatdetail().then((value) => {
      this.apiData = value;
      this.showSpinner = false;
    })

  }


  updateSubcategories() {
    if (this.selectedCategory !== null) {
      const selectedCategoryId = Number(this.selectedCategory);
      const categoryIds = Object.values(this.apiData).map(item => item.category.id);
      if (selectedCategoryId && categoryIds.includes(selectedCategoryId)) {
        const selectedCategory = Object.values(this.apiData).find(item => item.category.id === selectedCategoryId);
        this.subcategories = selectedCategory.category.subcategories;
      } else {
        this.subcategories = [];
      }
    } else {
      this.subcategories = []; // Reset subcategories if no category is selected
    }
  }

  updatecat() {
    const chcktpe = typeof (this.selectedSubcategory)
    if (this.selectedSubcategory) {

      // Assuming this.selectedSubcategory is already an object
      const subcategoryObject = this.selectedSubcategory;
      const jsonObject = JSON.parse(this.selectedSubcategory);
      // Ensure subcategories property exists and is an array
      if (subcategoryObject && Array.isArray(jsonObject.subcategories) && jsonObject.subcategories.length > 0) {
        // Assuming subcategories is an array within the object
        const firstSubcategory = jsonObject.subcategories[0];

        if (firstSubcategory && typeof firstSubcategory === 'object') {
          // Access the value of "is_media"
          const isMedia = firstSubcategory.is_media;

        } else {
          console.error('Invalid subcategory data');
        }
      } else {
        console.error('Subcategories property is missing or empty');
      }


    } else {
      // handle null/undefined case
    }

  }






  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
    // Use FileReader to read file and convert it to data URL
    const reader = new FileReader();
    reader.onload = () => {
      this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(reader.result as string);
    };
    reader.readAsDataURL(this.selectedFile);
  }


  // date filter
  acountfilter() {
    const startDate = this.start_Date
    const endDate = this.end_Date
    this.accountsServices.getamountfilter(startDate, endDate).then((value) => {
      this.showSpinner = false;
      this.filtedata = value.data;
      // Export filtered data after fetching
      if (this.filtedata.length != 0) {
        this.exportDataToExcel(this.filtedata, 'Data According to date');
        window.location.reload()

      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: 'No data is Found',
          showConfirmButton: false,
          timer: 1500,
        });
        window.location.reload()
      }
    });
  }

  exportData() {

    if (this.exportType === 'debit') {
      this.exportDebitData();
    } else if (this.exportType === 'credit') {
      this.exportCreditData();
    } else if (this.exportType === 'all_data') {
      this.exportAllData();
    } else {
      this.acountfilter();
    }

  }

  exportDebitData() {
    const debitData = this.user_Amount.filter(item => item.account_type === 'debit');
    if (!debitData || debitData.length === 0) {
      alert('No debit data available to export.');
    } else {
      this.exportDataToExcel(debitData, 'debit type data');
      window.location.reload()

    }
  }

  exportCreditData() {
    const creditData = this.user_Amount.filter(item => item.account_type === 'credit');
    if (!creditData || creditData.length === 0) {
      alert('No credit data available to export.');
    } else {
      this.exportDataToExcel(creditData, 'credit type data');
      window.location.reload()

    }
  }

  exportAllData() {
    const allData = this.user_Amount;
    this.exportDataToExcel(allData, 'all_data');
    window.location.reload()

  }

  exportDataToExcel(data: any[], filename: string) {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  }



  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }

  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }



  toggleHiddenDiv1() {
    this.showHiddenDiv1 = !this.showHiddenDiv1;
  }

  updateTab(tab: number) {
    this.currentTab = tab;
  }




  admindata() {
    this.showSpinner = true;

    this.accountsServices.getadmindetail().then((value) => {
      this.showSpinner = false;
      this.user_Amount = value.data;

      this.currentPage = 1;
      this.originalData = this.user_Amount?.slice();

    });
  }



  get paginatedData() {

    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.user_Amount?.slice(startIndex, startIndex + this.itemsPerPage);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  get totalPages() {
    return Math.ceil(this.user_Amount?.length / this.itemsPerPage);
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }


  chartvalue() {
    this.showSpinner = true;
    const id = this.user.id
    this.accountsServices.getchartdetail(id).then((value) => {

      this.showSpinner = false;

      const available = value.data.available
      const birthday = value.data.birthday
      const event = value.data.event
      const misaliance = value.data.misaliance
      const pattycash = value.data.pattycash
      const reserve = value.data.reserve
      const sport = value.data.sport




    }
    )
  }




  totalamount() {
    this.showSpinner = true;
    const id = this.user.id
    this.accountsServices.getadminalldetail().then((value) => {
      this.showSpinner = false;
      this.total_Amount = value.data.available_amount
      this.expense = value.data?.expense_amount
      this.reserve = value.data?.reserve_amount
      this.deposit = value.data?.total_deposit
      this.graphdataArray = [
        // { asset: "Total Available", amount:parseInt(this.total_Amount) },
        { asset: "Amount", amount: parseInt(this.total_Amount) },
        { asset: "Expese", amount: (-parseInt(this.expense)) },
        { asset: "Reserve", amount: parseInt(this.reserve) },
        { asset: "Deposit", amount: parseInt(this.deposit) },
      ]


      this.options = {
        series: [
          {
            data: this.graphdataArray,
            type: 'pie',
            angleKey: 'amount',
            calloutLabelKey: 'asset',
            sectorLabelKey: 'amount',
            sectorLabel: {
              color: 'white',
              fontWeight: "bold",
              formatter: ({ value }) => `RS:${(value / 1000).toFixed(0)}K/-`,
            },
            calloutLabel: {
              color: 'white',

              // fontWeight: 'bold'
            },

          },
        ],

        legend: {
          enabled: false,
        },


        background: {
          fill: 'transparent'
        },
      };



    }
    )
  }


  // edit accounts
  editaccount(data: any) {
    this.modalData = data;
    const modalElement: any = this.addExpenseModal.nativeElement;
    $(modalElement).modal('show');
    if (data && data.account_type === 'credit') {
      this.currentTab = 1;
    } else {
      this.currentTab = 2;
    }
    this.editeamount = this.modalData?.amount
    this.account_id = this.modalData?.id
    this.editedate = this.modalData?.date
    this.editedescription = this.modalData?.description
    this.editeexpense_type = this.modalData?.expense_type
  }

  onSubmit(form: NgForm) {
    if (this.account_id) {
      this.form_data = form.value;
      const formData = form.value;
      const ammount_type = this.currentTab;
      if (ammount_type == 1) {
        this.account_type = "credit";
      } else if (ammount_type == 2) {
        this.account_type = "debit";

      }
      this.accountsServices.editeacount(formData, this.account_id, this.account_type).then((value) => {
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 1500,
          });
          window.location.reload()
        }
        else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 1500,
          });
          window.location.reload()
        }

      })
    }
    else {
      this.form_data = form.value;
      const formData = form.value;
      const ammount_type = this.currentTab;
      if (ammount_type == 1) {
        this.account_type = "credit";
      } else if (ammount_type == 2) {
        this.account_type = "debit";

      }

      this.accountsServices.addamount(formData, this.account_type).then((value) => {
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Added Successfully',
            showConfirmButton: false,
            timer: 1500,
          });
          window.location.reload()
        } else {
          const totalAmountString = this.total_Amount;
          const totalAmountNumber = parseInt(totalAmountString);
          const total_remaining = this.reserve + totalAmountNumber
          if (form.value.total_amount > totalAmountNumber && form.value.total_amount < total_remaining) {
            this.openErrorModal();
          }
          else if (form.value.total_amount > totalAmountNumber && form.value.total_amount > total_remaining) {
            Swal.fire({
              iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
              title: value.message,
              showConfirmButton: false,
              timer: 1500,
            });
            window.location.reload()
          }
        }
      })
    }



  }
  reserveamount() {
    this.form_data
    this.accountsServices.reservecal(this.form_data, this.account_type).then((value) => {

      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Added Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        window.location.reload()
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
        window.location.reload()
      }
    })
  }


  openErrorModal() {
    // Close the first modal
    if (this.addExpenseModal) {
      const addExpenseModal: any = this.addExpenseModal.nativeElement;
      $(addExpenseModal).modal('hide');
    }

    // Open the second modal
    if (this.errorModal) {
      const errorModal: any = this.errorModal.nativeElement;
      $(errorModal).modal('show');
    }
  }

  closeErrorModal() {
    if (this.errorModal) {
      const errorModal: any = this.errorModal.nativeElement;
      $(errorModal).modal('hide');
    }
  }


  getExpenseColor(expenseType: string): string {
    switch (expenseType) {
      case 'events':
        return '#FFF7F1';
      case 'sports':
        return '#E9EDD0';
      case 'misalliance':
        return '#EEE5EF';
      case 'birthday':
        return '#D0F1D8';
      case 'patty_cash':
        return '#E6EDF1';
      case 'available':
        return '#D1F5D3';
      case 'reserve':
        return '#C6F8DE';
      default:
        return 'white';
    }
  }
  getColor(expenseType: string): string {
    switch (expenseType) {
      case 'events':
        return '#FFB600';
      case 'sports':
        return '#FF4454';
      case 'misalliance':
        return '#4F6DD6';
      case 'birthday':
        return '#006DA0';
      case 'patty_cash':
        return '#00BFE6';
      case 'available':
        return '#0D936B';
      case 'reserve':
        return '#00D1DC';
      default:
        return 'red';
    }
  }

  selectFunction() {
    switch (this.selectedOption) {
      case 'reserve':
        this.filterreserve();
        break;
      case 'events':
        this.filterevents();
        break;
      case 'sports':
        this.filtersports();
        break;
      case 'birthday':
        this.filterbirthday();
        break;
      case 'patty_cash':
        this.filterpatty_cash();
        break;
      case 'misalliance':
        this.filtermisalliance();
        break;
      case 'available':
        this.filteravailable();
        break;
      case 'all':
        this.filterall();
        break;

      default:
        break;
    }
  }
  filterreserve() {

    this.user_Amount = this.originalData.filter(item => item.expense_type === 'reserve');

  }
  filterevents() {
    this.user_Amount = this.originalData.filter(item => item.expense_type === 'events')
  }
  filtersports() {
    this.user_Amount = this.originalData.filter(item => item.expense_type === 'sports')
  }
  filterbirthday() {
    this.user_Amount = this.originalData.filter(item => item.expense_type === 'birthday')
  }
  filterpatty_cash() {
    this.user_Amount = this.originalData.filter(item => item.expense_type === 'patty_cash')
  }
  filtermisalliance() {
    this.user_Amount = this.originalData.filter(item => item.expense_type === 'misalliance')
  }
  filteravailable() {
    this.user_Amount = this.originalData.filter(item => item.expense_type === 'available')
  }
  filterall() {
    this.user_Amount = this.originalData
  }


  selectexpense_typ() {
    switch (this.selectedOption) {
      case 'debit':
        this.filterdebit();
        break;
      case 'credit':
        this.filtcredit();
        break;
      case 'both':
        this.filtboth();
        break
      default:
        break;
    }
  }

  filterdebit() {
    this.user_Amount = this.originalData.filter(item => item.account_type === 'debit');
  }

  filtcredit() {
    this.user_Amount = this.originalData.filter(item => item.account_type === 'credit');
  }
  filtboth() {
    this.user_Amount = this.originalData;
  }



  // updatedata(editeamount :any,editedate:any,editeexpense_type:any,editedescription:any){
  //  if(this.currentTab == 1){
  //   this.tab = 'credit',
  //   editeexpense_type = ''

  // }else{
  //   this.tab  = 'debit'
  // }
  // let id = this.modalData.id
  //   let amount = editeamount
  //   let date = editedate
  //   let expense = editeexpense_type
  //   let description = editedescription
  //   let current_tab = this.tab

  //   this.accountsServices.editeacount(id,amount, date, expense, description,current_tab).then((value) => {

  //     })


  // }
  delete_account(data: any) {
    const a = data
    this.id = a.id
  }
  deleteaccount() {
    const account_id = this.id
    this.accountsServices.deleteacount(account_id).then((value) => {
      if (value.success == true) {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: 'Deleted Successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        window.location.reload()
      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: value.message,
          showConfirmButton: false,
          timer: 1500,
        });
        window.location.reload()
      }
    })

  }


  applyfilter() {
    this.startDate
    this.endDate
    this.accountsServices.getamountfilter(this.startDate, this.endDate).then((value) => {
      this.showSpinner = false;
      this.filtedata = value.data;
      // Export filtered data after fetching
      if (this.filtedata.length != 0) {
        this.user_Amount = this.filtedata

      }
      else {
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
          title: 'No data is Found',
          showConfirmButton: false,
          timer: 1500,
        });
        window.location.reload()
      }
    });

  }



  opentab(event: any, tabName: string) {
    this.selectedtab = tabName;
  }

  getuserdetail(data: any, account_id: any) {
    const user_id = data.id;
    const data_id = account_id
    if (account_id) {
      this.router.navigate(['/accounts-managment'],
        { queryParams: { user_id: user_id } }
      );
    }
    else {
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
        title: 'No data is Found',
        showConfirmButton: false,
        timer: 1500,
      });
    }

  }


}
